import { useSelector } from "react-redux";
import { MODULES, ROLE } from "../utils/enums";

function useAuthorization() {
  const { permissions, role_id } = useSelector((state) => state.user);
  const isReadOnly = +role_id === ROLE.READ_ONLY;
  
  const isAuthorize = (module_id, action) => {
    const modId = Array.isArray(module_id) ? +module_id[0] : +module_id;
    if ([MODULES.DOMAINS, MODULES.CUSTOM_FIELDS].includes(modId) && [ROLE.LOCATION_ADMIN, ROLE.ACCOUNT_ADMIN].includes(+role_id)) {
      return true;
    }
    if (modId === MODULES.CUSTOM_FIELDS && +role_id === ROLE.LOCATION_STAFF && action === 'view') {
      return true;
    }
    if (permissions && permissions[modId] && permissions[modId][action]) {
      return true;
    } else {
      return false;
    }
  }

  return { isAuthorize, role_id, permissions, isReadOnly }
}

export default useAuthorization